/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends SelectProps {
    labelOverride?: React.ReactNode;
    disabled?: boolean;
    extendedStyles?: SelectPresentationProps;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasProductContext;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export const productUnitOfMeasureSelectStyles: SelectPresentationProps = {};

const ProductUnitOfMeasureSelect: React.FC<Props> = ({
    productContext: {
        product: { unitOfMeasures,properties },
        productInfo: { unitOfMeasure, productId },
        onUnitOfMeasureChanged,
    },
    disabled,
    productSettings,
    labelOverride,
    extendedStyles,
    ...otherProps
}) => {
    const [styles] = React.useState(() => mergeToNew(productUnitOfMeasureSelectStyles, extendedStyles));
    const callForPricing = properties ? properties["item_CallForPricing"] : "";
    const isCallForPricing = callForPricing?.toString().toLowerCase() === "true";
    if (
        !productSettings?.alternateUnitsOfMeasure ||
        !unitOfMeasures ||
        unitOfMeasures.filter(uom => uom.unitOfMeasure).length <= 1 ||
        isCallForPricing
    ) {
        return null;
    }

    const uomChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (!onUnitOfMeasureChanged) {
            logger.warn(`There was no onUnitOfMeasureChanged passed to the ProductContext for ${productId}`);
            return;
        }
        onUnitOfMeasureChanged(event.target.value);
    };


    const isDiscontinuedProduct = properties && (properties["item_InventoryTypeDesc"]?.includes('Discontinued')) ? true : false;
    const customCssWrapper = {
        css: css`
            // &.unit-measure-section{
            //     label + [class*="FormInputWrapper"]{
            //         max-width: 70px;
            //     }
            //     .unit-measure-wrap{
            //         margin-bottom: 6px;
            //     }
            //     [class*="FormInputWrapper"]{
            //         margin-top: 2px !important;
            //     }
            // }
        `,
    };
    return (
        <Typography as="div" className="unit-measure-section" {...customCssWrapper}>
        {unitOfMeasures.length > 1 && (     
        <Select
            label={labelOverride ?? translate("U/M:")}
            value={unitOfMeasure}
            onChange={uomChangeHandler}
            disabled={disabled || isDiscontinuedProduct}
            data-test-selector="product_unitOfMeasureSelect"
            {...styles}
            {...otherProps}
            className="unit-measure-wrap"
        >
            {unitOfMeasures.map(uom => (
                <option key={uom.id.toString()} value={uom.unitOfMeasure}>
                    {uom.description ? uom.description : uom.unitOfMeasureDisplay}{" "}
                    {uom.qtyPerBaseUnitOfMeasure !== 1 ? `/${uom.qtyPerBaseUnitOfMeasure}` : ""}
                </option>
            ))}
        </Select>
    )}
    </Typography>
    );
};

export default connect(mapStateToProps)(withProductContext(ProductUnitOfMeasureSelect));
